import React, { Component } from 'react'
import LoanTypeAndEventMappingPageUI from './LoanTypeAndEventMappingPageUI'
import LoanTypeAndEventMappingEditModalSF from '../../../components/superUser/loanTypeAndEventMapping/LoanTypeAndEventMappingEditModalSF'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'

class LoanTypeAndEventMappingPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loanTypes: [],
      loanSubTypes: [], // <-- Store subtypes here
      mappings: [],
      loading: true,
      error: null,
      activeTab: 'Amortized',
      activeSubType: 'All',
      editModalOpen: false,
      selectedMapping: null
    }
  }

  componentDidMount() {
    // Fetch subtypes first, then loan types and mappings
    this.fetchLoanSubTypes()
    this.fetchMappings()
  }

  fetchLoanSubTypes = () => {
    this.setState({ loading: true })
    RestApiUtils.get(this.props.context, '/api/reference/loan/subTypes', this.handleLoanSubTypesResponse)
  }

  handleLoanSubTypesResponse = (data) => {
    if (data && data.loanSubTypeList && data.loanSubTypeList.length > 0) {
      const loanSubTypes = data.loanSubTypeList.map(item => ({
        code: item.code,
        title: item.title
      }))
      this.setState({ loanSubTypes }, this.initializeLoanTypes) // Fetch loan types after subtypes
    } else {
      // Fallback if API fails
      this.setState({ loanSubTypes: [{ code: 'standard', title: 'Standard' }], loading: false }, this.initializeLoanTypes)
    }
  }

  initializeLoanTypes = () => {
    // Fetch loan types from the API
    this.setState({ loading: true })
    RestApiUtils.get(this.props.context, '/api/reference/loanTypes', this.handleLoanTypesResponse)
  }

  handleLoanTypesResponse = (data) => {
    try {
      if (data && data.keyValueList && data.keyValueList.length > 0) {
        // Transform the API response to match our component's expected format
        // Use fetched subtypes for all loan types
        const subTypes = this.state.loanSubTypes.length > 0
          ? this.state.loanSubTypes.map(st => st.title)
          : ['Standard', 'All']
        const loanTypes = data.keyValueList.map(item => ({
          name: item.value, // Using the display name from the API
          key: item.key,     // Store the key for reference
          subTypes: subTypes // Use fetched subtypes
        }))
        
        this.setState({ 
          loanTypes,
          activeTab: loanTypes[0].name,
          loading: false,
          error: null
        })
      } else {
        throw new Error('No loan types found')
      }
    } catch (error) {
      console.error('Error processing loan types response:', error)
      this.setState({
        error: 'Failed to process loan types data. Please try again later.',
        loading: false
      })
      this.setDefaultLoanTypes()
    }
  }

  setDefaultLoanTypes = () => {
    // Fallback to default loan types in case of error
    const defaultLoanTypes = [
      {
        name: 'Amortized',
        key: 'project',
        subTypes: this.state.loanSubTypes.length > 0
          ? this.state.loanSubTypes.map(st => st.title)
          : ['Standard', 'All']
      },
      {
            name: 'Interest Only',
            key: 'interest_only',
            subTypes: this.state.loanSubTypes.length > 0
              ? this.state.loanSubTypes.map(st => st.title)
              : ['Standard', 'All']
          }
        ]
        
        this.setState({ 
          loanTypes: defaultLoanTypes,
          activeTab: defaultLoanTypes[0].name
        })
  }

  fetchMappings = (loanType = '', subLoanType = 'All') => {
    this.setState({ loading: true })
    
    // If called without parameters, use the state's active selections
    const activeType = loanType || this.state.activeTab
    const activeSubType = subLoanType !== 'All' ? subLoanType : ""
    
    // Construct the API endpoint with query parameters
    // const endpoint = `/api/su/notifyLoanEventMapping/getNotifyLoanEventMappingByLoanAndSubLoanType?loanType=${encodeURIComponent(activeType)}&subLoanType=${encodeURIComponent(activeSubType)}`
    const endpoint = `/api/su/notifyLoanEventMapping/getNotifyLoanEventMappingByLoanAndSubLoanType?loanType=&subLoanType=`
    
    RestApiUtils.get(this.props.context, endpoint, this.handleMappingsResponse)
  }
  
  handleMappingsResponse = (data) => {
    console.log("data", data)
    try {
      if (data && data.dataList && Array.isArray(data.dataList)) {
        // Transform the API response data to match our component's expected format
        const mappings = data.dataList.map(item => ({
          id: item.eventId.toString(),
          loanType: item.loanType,
          subType: item.subLoanType,
          // You'll need to fetch event details to get category and eventName
          // or add them to the API response if possible
          category: item.eventGroup, // Placeholder - replace with actual data when available
          eventName: item.eventName, // Placeholder - replace with actual data when available
          sequence: item.sequence,
          whatsappTemplateId: item.whatsappTemplateId,
          emailTemplateId: item.emailTemplateId,
          positiveWhatsappTemplateId: item.positiveWhatsappAckTemplateId,
          negativeWhatsappTemplateId: item.negativeWhatsappAckTemplateId,
          positiveEmailTemplateId: item.positiveEmailAckTemplateId,
          negativeEmailTemplateId: item.negativeEmailAckTemplateId,
          isEnabled: item.isEnabled,
          notificationChannels: item.notificationChannels,
          status: item.isEnabled ? 'Active' : 'Inactive'
        }))
        
        this.setState({
          mappings,
          loading: false,
          error: null
        })
      } else {
        // Return empty mappings array when no data is available
        this.setState({
          mappings: [],
          loading: false,
          error: null
        })
      }
    } catch (error) {
      this.setState({
        loading: false,
        error: 'Failed to process mappings data. Please try again later.'
      })
      console.error('Error processing mappings response:', error)
    }
  }

  handleTabChange = (tab) => {
    this.setState({
      activeTab: tab,
      activeSubType: 'All'
    }, () => {
      // Fetch mappings for the new tab
      this.fetchMappings(tab, 'All')
    })
  }

  handleSubTypeChange = (subType) => {
    this.setState({ activeSubType: subType }, () => {
      // Fetch mappings for the new subtype
      this.fetchMappings(this.state.activeTab, subType)
    })
  }

  handleEditClick = (mapping) => {
    this.setState({
      editModalOpen: true,
      selectedMapping: mapping
    })
    console.log("mapping", mapping)
  }

  handleCancelEdit = () => {
    this.setState({
      editModalOpen: false,
      selectedMapping: null
    })
  }

  handleMappingUpdated = (updatedMapping) => {
    // Update the mapping in the list
    const updatedMappings = this.state.mappings.map(mapping => {
      if (mapping.id === updatedMapping.id) {
        return {
          ...mapping,
          ...updatedMapping
        }
      }
      return mapping
    })

    this.setState({
      mappings: updatedMappings
    })

    // Here you would typically update the backend via API call as well
    // updateMappingInBackend(updatedMapping);
  }

  render() {
    // Display all mappings from the API response
    // We're not filtering here since the API already returns filtered data
    const filteredMappings = this.state.mappings

    return (
      <>
        <LoanTypeAndEventMappingPageUI
          context={this.props.context}
          loanTypes={this.state.loanTypes}
          mappings={filteredMappings}
          loading={this.state.loading}
          error={this.state.error}
          activeTab={this.state.activeTab}
          activeSubType={this.state.activeSubType}
          onTabChange={this.handleTabChange}
          onSubTypeChange={this.handleSubTypeChange}
          onEditClick={this.handleEditClick}
        />

        <LoanTypeAndEventMappingEditModalSF
          context={this.props.context}
          messageList={[]}
          editMode={this.state.editModalOpen}
          selectedMapping={this.state.selectedMapping}
          onCancel={this.handleCancelEdit}
          onMappingUpdated={this.handleMappingUpdated}
        />
      </>
    )
  }
}
export default LoanTypeAndEventMappingPageSF
